declare global {
  interface Window {
    __env__: {
      API_URL: string;
      ENVIRONMENT: string;
      COMPANY_NAME: string;
    };
  }
}

const API_URL = window.__env__?.API_URL || import.meta.env.VITE_API_URL || '';

const ENVIRONMENT =
  window.__env__?.ENVIRONMENT ||
  import.meta.env.VITE_ENVIRONMENT ||
  'production';

const COMPANY_NAME =
  window.__env__?.COMPANY_NAME ||
  import.meta.env.VITE_COMPANY_NAME ||
  'Asia Finance Group';

export const IS_DEV = ENVIRONMENT === 'development';
export const IS_PROD = ENVIRONMENT === 'production';

export const config = {
  API_URL,
  ENVIRONMENT,
  IS_DEV,
  IS_PROD,
  COMPANY_NAME,
};
